import { getCookie, setCookie } from 'cookies-next/client'

import {
  COOKIE_AD_SERVER_BROWSER_ID_CONVERSION_NAME,
  COOKIE_AD_SERVER_BROWSER_ID_TARGETING_NAME,
  COOKIE_NAME_USER_CONSENT,
} from '../cookies'

import {
  AD_SERVER_BROWSER_ID_CONVERSION_COOKIE_MAX_AGE,
  AD_SERVER_BROWSER_ID_TARGETING_COOKIE_MAX_AGE,
} from './adServerConst'

const adServerCookieSetBrowserIdConversion = (uuid: string): void => {
  setCookie(COOKIE_AD_SERVER_BROWSER_ID_CONVERSION_NAME, uuid, {
    httpOnly: false,
    maxAge: AD_SERVER_BROWSER_ID_CONVERSION_COOKIE_MAX_AGE,
    path: '/',
  })
}

const adServerCookieGetAdBrowserIdConversion = (): string | undefined => {
  return getCookie(COOKIE_AD_SERVER_BROWSER_ID_CONVERSION_NAME)
}

const adServerCookieGetAdBrowserIdConversionOrGenerate = (): string => {
  const adBrowserIdConversion = adServerCookieGetAdBrowserIdConversion()

  if (adBrowserIdConversion) {
    return adBrowserIdConversion
  }

  const uuid = crypto.randomUUID()

  adServerCookieSetBrowserIdConversion(uuid)

  return uuid
}

const adServerCookieGetAdBrowserIdTargeting = (): string | undefined => {
  return getCookie(COOKIE_AD_SERVER_BROWSER_ID_TARGETING_NAME)
}

const adServerCookieSetAdBrowserIdTargeting = (uuid: string): void => {
  setCookie(COOKIE_AD_SERVER_BROWSER_ID_TARGETING_NAME, uuid, {
    httpOnly: false,
    maxAge: AD_SERVER_BROWSER_ID_TARGETING_COOKIE_MAX_AGE,
    path: '/',
  })
}

const COOKIE_NAME_AD_STORAGE = 'ad_storage'

export const adServerCookieGetUserConsentForAdStorage = (): boolean => {
  const consentCookie = getCookie(COOKIE_NAME_USER_CONSENT)

  if (typeof consentCookie !== 'string') {
    return false
  }

  // eslint-disable-next-line unicorn/try-complexity -- don't reference, refactor if touched
  try {
    const consent = JSON.parse(consentCookie) as Partial<
      Record<string, boolean | number>
    >
    const adStorageValue = consent[COOKIE_NAME_AD_STORAGE]

    /**
     * For non-com tenants the truthy value is 1 instead of true
     * See: https://jira.shop-apotheke.com/browse/RMADT-3495
     */
    return adStorageValue === true || adStorageValue === 1
  } catch {
    return false
  }
}

const adServerCookieGetAdBrowserTargetingIdOrGenerate = ():
  string | undefined => {
  if (!adServerCookieGetUserConsentForAdStorage()) {
    return undefined
  }

  const adBrowserIdTargeting = adServerCookieGetAdBrowserIdTargeting()

  if (adBrowserIdTargeting) {
    return adBrowserIdTargeting
  }

  const uuid = crypto.randomUUID()
  adServerCookieSetAdBrowserIdTargeting(uuid)

  return uuid
}

/**
 * checks if generated ids are present on cookies,
 * if present, return them
 * if not generates, saves them on cookies and returns.
 */
export const adServerCookiesGetOrGenerateUserIdentity = (): {
  browserIdConversion: string
  browserIdTargeting?: string
} => {
  return {
    browserIdConversion: adServerCookieGetAdBrowserIdConversionOrGenerate(),
    browserIdTargeting: adServerCookieGetAdBrowserTargetingIdOrGenerate(),
  }
}
